import { Button } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { H6, Body3 } from '../../../../../themes/typography';

function KycInfoSidebar() {
    return (
        <div className="kyc-info-sidebar-container">
            <div className="kyc-info-icon-header">
                <div className="kyc-info-icon">
                    <AdminPanelSettingsIcon color="tertiary" sx={{ fontSize: '3rem' }} />
                </div>
            </div>

            <div className="kyc-info-title-desc">
                <H6 color="var(--secondary-color)" fontWeight={700}>
                    Why do we need this information?
                </H6>
                <Body3>
                    Your identity verification is essential to ensure shmooz remains a safe,
                    credible and trustworthy platform for everyone. This helps us:
                </Body3>
            </div>

            <div className="kyc-info-points-list-container">
                <div className="kyc-point">
                    <div className="kyc-dot"></div>
                    <Body3 fontWeight={400}>Prevent fraud and scams.</Body3>
                </div>
                <div className="kyc-point">
                    <div className="kyc-dot"></div>
                    <Body3 fontWeight={400}>Protect attendees from deceptive events.</Body3>
                </div>
                <div className="kyc-point">
                    <div className="kyc-dot"></div>
                    <Body3 fontWeight={400}>
                        Maintain a secure environment for all creators and users.
                    </Body3>
                </div>
            </div>

            <div className="community-message-container">
                <Body3>
                    We are building a community where everyone can discover and create experiences
                    with confidence.
                </Body3>
            </div>

            <div className="learn-more-about-btn">
                <Button
                    fullWidth
                    sx={{
                        fontSize: '0.875rem',
                        border: '1px solid var(--tertiary-color)',
                        color: 'var(--tertiary-color)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            color: 'var(--secondary-color)',
                            backgroundColor: 'transparent',
                            borderColor: 'var(--secondary-color)'
                        }
                    }}
                >
                    Click to know more →
                </Button>
            </div>
        </div>
    );
}

export default KycInfoSidebar;
